import activityApiMap from './activityApiMap';
import apimapConfig from './apimap.config';
import newOrderApiMap from './newOrderApiMap';

export default { ...apimapConfig, ...newOrderApiMap, ...activityApiMap };
